// material
import { styled } from '@mui/material/styles'
// components
import { ProfileInfoItem } from '$common/profile-info-item'
// Localization
import { t } from '$i18n'
import { useClientUser } from '$logic/client-user/react-hook'
import { openEditBio, openEditUsername } from '$logic/router'

export function MyAccountProfileInfo() {
  const user = useClientUser()

  return (
    <Root>
      <ProfileInfoItem
        placeholder={t('myAccount.addUserName')}
        label={t('user.username')}
        value={user?.username ? `@${user.username}` : null}
        onClick={() => {
          if (user?.id) openEditUsername()
        }}
        showIcon
      />
      <ProfileInfoItem
        placeholder={t('myAccount.addBio')}
        label={t('user.bio')}
        value={user?.bio}
        onClick={() => {
          if (user?.id) openEditBio()
        }}
        showIcon
      />
    </Root>
  )
}

const Root = styled('div')`
  background-color: ${({ theme }) => theme.palette.neutral000};
  padding: 8px 0;
  border-radius: 12px;
  box-shadow: ${({ theme }) => theme.shadows[3]};
  width: 100%;
`
